import {
  AutoComplete,
  Button,
  Input,
  Modal,
  Select,
  Tag,
  Tooltip,
  Checkbox,
} from "antd";
import React, { useState } from "react";
import "Benchmarking/Scss/SearchAdvanceFacultyModal.scss";
import {
  classification_select,
  position_select,
  seniority_select,
  state_select,
} from "Benchmarking/Config/SelectData";
import Search from "antd/es/input/Search";
import { getSuggestSearchInstitutions } from "Explore/Services/Institution";

const SearchAdvanceInstitutionModal = ({ filters, setFilters }) => {
  const [currentSearchQueryValue, setCurrentSearchQueryValue] = useState("");
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);

  const tagRenderForSelect = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          height: "28px",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };

  const tagRender = (label, closable, onClose) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };

  const handleInputChangeInstitution = (value) => {
    if (value) {
      getSuggestSearchInstitutions(value, (res) => {
        setInstitutionOptions(
          res.map((item) => {
            return {
              ...item,
              value: item.name,
            };
          })
        );
      });
      setCurrentSearchQueryValue(value);
    } else {
      setFilters({ ...filters, query: null });
      setCurrentSearchQueryValue("");
    }
  };

  const handleInputConfirmInstitution = (value, option) => {
    setFilters({
      ...filters,
      query: `${option.name}`,
    });
  };

  const onChangeClassification = (value) => {
    setFilters({
      ...filters,
      classifications: value,
    });
  };
  const onChangeState = (value) => {
    setFilters({
      ...filters,
      states: value,
    });
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <div className="search-advanced-faculty-modal">
      <div className="search-bar">
        <AutoComplete
          options={institutionOptions}
          placeholder="Enter to search"
          onChange={handleInputChangeInstitution}
          onSelect={handleInputConfirmInstitution}
          style={{ width: "80%" }}
        >
          <Input
            style={{ height: "35px" }}
            onPressEnter={() => {
              setFilters({ ...filters, query: currentSearchQueryValue });
            }}
          />
        </AutoComplete>
        <div
          className="advanced-search-button"
          onClick={() => setOpenAdd(!openAdd)}
          style={{
            backgroundColor: openAdd
              ? "var(--explore-color)"
              : "var(--benchmarking-color)",
          }}
        >
          <p>{openAdd ? "Close Advanced search" : "Advanced Search"}</p>
        </div>
      </div>
      {openAdd && (
        <div className="advanced-search">
          <div style={{ marginBottom: "10px" }}>
            <Select
              className="filter-item"
              showSearch
              value={filters.states ? filters.states : []}
              placeholder="State"
              optionFilterProp="children"
              mode="multiple"
              allowClear
              tagRender={tagRenderForSelect}
              onChange={onChangeState}
              filterOption={filterOption}
              options={state_select}
              style={{ width: "49%", height: "35px", marginRight: "2%" }}
            />
            <Select
              mode="multiple"
              value={filters.classifications ? filters.classifications : []}
              allowClear
              className="filter-item"
              showSearch
              tagRender={tagRenderForSelect}
              placeholder="Classification"
              optionFilterProp="children"
              onChange={onChangeClassification}
              filterOption={filterOption}
              options={classification_select}
              style={{ width: "49%", height: "35px" }}
            />
          </div>
        </div>
      )}
      {!openAdd && (
        <div className="filters-search-modal">
          {filters.states && (
            <div className="group-filters">
              <p>State: </p>
              {filters.states.map((item) => tagRender(item, null, null))}
            </div>
          )}
          {filters.classifications && (
            <div className="group-filters">
              <p>Classification: </p>
              {filters.classifications.map((item) =>
                tagRender(item, null, null)
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchAdvanceInstitutionModal;
